import { createAltenarSession } from '../api/altenar-service.api';

export const createAltenarSessionRequest = async () => {
    const response = await createAltenarSession();
    return response.data;
};

